import React from 'react';
import BackButton from './Sub/BackButton';
import SubNavigationBar from './SubNavigationBar';

interface Props {
  children: React.ReactNode;
  defaultBack: string;
  title: string;
  isGoBackHistory?: boolean;
}

function SubNavigationBarWithBackButton({
  children,
  defaultBack,
  title,
  isGoBackHistory,
}: Props) {
  return (
    <SubNavigationBar className="mio-sub-nav__with-back-button">
      <SubNavigationBar.BackButton defaultBack={defaultBack} isGoBackHistory={isGoBackHistory} />
      <div className="mio-sub-nav__sep-line" />
      {title ? (
        <div className="mio-sub-nav__sub-title">{title}</div>
      ) : (
        undefined
      )}
      {children}
    </SubNavigationBar>
  );
}

SubNavigationBarWithBackButton.defaultProps = {
  defaultBack: '/',
  title: undefined,
  children: null,
} as Partial<Props>;

SubNavigationBarWithBackButton.BackButton = BackButton;

export default SubNavigationBarWithBackButton;
